import { render } from "./AnnotationSearchResult.vue?vue&type=template&id=1dab6e46"
import script from "./AnnotationSearchResult.vue?vue&type=script&lang=js"
export * from "./AnnotationSearchResult.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__